import React from "react";
import { toggle } from "../../../util/common";
import { IPersonalInformation } from "../../../store/credit/types";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { getFormattedDate } from "../../../util/dateFormatting";
import { useTranslation } from "react-i18next";

interface IProps {
    data?: IPersonalInformation[];
}

const CreditHistoryPersonalInfo: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    let col = null;
    if (props.data != null) {
        col = props.data;
    }

    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    <button
                        aria-expanded="false"
                        className="btn-default btn-toggle btn-drawer"
                        id="btn-personal-information"
                        onClick={() => toggle("personal-information", "btn-personal-information")}
                    >
                        <span className="btn-toggle-status sr-only">Show</span>
                        <span className="btn-text">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.personnalInformationSection.title")}</span>
                    </button>
                </div>

                <div className="drawer-content" id="personal-information" style={{ display: "none" }}>
                    <h3 className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.personnalInformationSection.title")}</h3>
                    <div className="table-container scroll">
                        {col != null ? (
                            <table className="m-table-generic">
                                <caption className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.personnalInformationSection.titleInfo")}</caption>
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <span className="sr-only">Item</span>
                                        </th>
                                        {col.map((personalInfo: IPersonalInformation) => (
                                            <th key={personalInfo.bureau} scope="col">
                                                {personalInfo.bureau}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row" className="table-label">
                                            {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.personnalInformationSection.name")}
                                        </th>
                                        {col.map((personalInfo: IPersonalInformation) => (
                                            <td key={personalInfo.bureau + personalInfo.borrowerName + "_personalInfoName"}>{personalInfo.borrowerName}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <th scope="row" className="table-label">
                                            {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.personnalInformationSection.dateOfBirth")}
                                        </th>
                                        {col.map((personalInfo: IPersonalInformation) => (
                                            <td key={personalInfo.bureau + personalInfo.borrowerName + "_personalInfoDOB"}>
                                                {getFormattedDate(i18nService.get("Country"), personalInfo.birth)}
                                            </td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CreditHistoryPersonalInfo;
